exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".farm-list-management-page .side-menu .side-menu-template .menu-header h3 {\n  margin-bottom: 20px;\n}", ""]);

// exports
